/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  trackMessageFieldConversionEvent traktor thunk
 */

import { getUser } from '@zcode-ui/web-zumper-global-state'
import {
  event,
  EMAIL_ENTERED,
  FLOORPLAN_SELECTED,
  LISTING_SELECTED,
  MOVE_IN_ENTERED,
  NAME_ENTERED,
  PHONE_ENTERED,
} from '@zcode-ui/web-zumper-integrations'

const MSG_FIELD_CONVERSION_MAP = {
  name: NAME_ENTERED,
  phone: PHONE_ENTERED,
  email: EMAIL_ENTERED,
  moveIn: MOVE_IN_ENTERED,
  selectedFloorplanId: FLOORPLAN_SELECTED,
  selectedListingId: LISTING_SELECTED,
}

export const trackMessageFieldConversionEvent =
  ({ key, value }) =>
  (dispatch, getState) => {
    const name = MSG_FIELD_CONVERSION_MAP[key]
    const state = getState()
    const user = getUser(state)
    dispatch(event({ name, user, props: { value } }))
  }
